import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/editor/reducers'
import { getInitialState } from 'store/features/editor/initialState'

const editorSlice = createSlice({
  name: 'editor',
  initialState: getInitialState(),
  reducers
})

export default editorSlice
